import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Suites from './suitesFloors';

Vue.config.productionTip = false
Vue.prototype.townToShow ="",
Vue.mixin({
  data() {
    return {
      currentPage: '',
      Suites: Suites,
      townToShow: "traditional",
    }
  },
  methods: {
    getTown(name) {
      return this.Suites[name];
    }, 
  },
  mounted(){
    let inactivityTime = function() {
      let time;
      window.onload = resetTimer;
      document.onmousemove = resetTimer;
      document.onkeypress = resetTimer;
      console.log('timer started');
      function logout() {
        console.log("You are now logged out.");
        window.location.replace("http://sxsw-main.joeyai.tv/");

      }
      function resetTimer() {
        console.log('timer reset');
        clearTimeout(time);
        time = setTimeout(logout, 3000000);
      }
    };
    window.onload = function() {
      inactivityTime();
    }
  }
});

new Vue({
  router,
  render: function (h) { return h(App) },  
}).$mount('#app')
